import { ArrowRightLeft, Bot, Check, Download, Headset, Megaphone, Settings, Shapes } from "lucide-react";
import { MarktingCard } from "../../AvatarDigitalMarketer/AiMarketingTeam";
import Box from "../../components/Box";
import Text from "../../components/Text";

const resultsPointsCard1 = [
    { icon: <Check className="w-4 h-4 text-[#4949DE]" />, text: "Reach up to 1 lakh new parents" },
    { icon: <Check className="w-4 h-4 text-[#4949DE]" />, text: "Boost admissions by ₹2.5 crores" },
    { icon: <Check className="w-4 h-4 text-[#4949DE]" />, text: "Zero manual work" },
];

const resultsPointsCard2 = [
    { icon: <Check className="w-4 h-4 text-[#4949DE]" />, text: "Better student results" },
    { icon: <Check className="w-4 h-4 text-[#4949DE]" />, text: "Happier teachers" },
    { icon: <Check className="w-4 h-4 text-[#4949DE]" />, text: "Stronger parent trust" },
];

const resultsPointsCard3 = [
    { icon: <Check className="w-4 h-4 text-[#4949DE]" />, text: "Reach up to 1 lakh new parents" },
    { icon: <Check className="w-4 h-4 text-[#4949DE]" />, text: "Boost admissions by ₹2.5 crores" },
    { icon: <Check className="w-4 h-4 text-[#4949DE]" />, text: "Zero manual work" },
];

const resultsPointsCard4 = [
    { icon: <Check className="w-4 h-4 text-[#4949DE]" />, text: "Zero downtime" },
    { icon: <Check className="w-4 h-4 text-[#4949DE]" />, text: "Fast issue fixing" },
    { icon: <Check className="w-4 h-4 text-[#4949DE]" />, text: "Complete peace of mind" },
];

const buttonPointsCard1 = [
    { icon: <Bot className="w-4 h-4 text-[#4949DE]" />, text: "Instant Website Developer" },
    { icon: <Bot className="w-4 h-4 text-[#4949DE]" />, text: "SEO Specialist" },
    { icon: <Bot className="w-4 h-4 text-[#4949DE]" />, text: "Social Media Manager" },
    { icon: <Bot className="w-4 h-4 text-[#4949DE]" />, text: "Automated Reels & Video Maker" },
    { icon: <Bot className="w-4 h-4 text-[#4949DE]" />, text: "24/7 Virtual Admissions Counsellor" },
];

const buttonPointsCard2 = [
    { icon: <Bot className="w-4 h-4 text-[#4949DE]" />, text: "SuperStudent" },
    { icon: <Bot className="w-4 h-4 text-[#4949DE]" />, text: "1st Rank" },
    { icon: <Bot className="w-4 h-4 text-[#4949DE]" />, text: "AI Parent Helpdesk" },
    { icon: <Bot className="w-4 h-4 text-[#4949DE]" />, text: "AI Child Care" },
];

const buttonPointsCard3 = [
    { icon: <Bot className="w-4 h-4 text-[#4949DE]" />, text: "Multilingual Communication" },
    { icon: <Bot className="w-4 h-4 text-[#4949DE]" />, text: "Auto Fee Collection" },
    { icon: <Bot className="w-4 h-4 text-[#4949DE]" />, text: "Parental Feedback" },
    { icon: <Bot className="w-4 h-4 text-[#4949DE]" />, text: "Homework Assist" }
];

const buttonPointsCard4 = [
    { icon: <Bot className="w-4 h-4 text-[#4949DE]" />, text: "Self-Healer" },
    { icon: <Bot className="w-4 h-4 text-[#4949DE]" />, text: "Record & Report" },
    { icon: <Bot className="w-4 h-4 text-[#4949DE]" />, text: "Virtual Relationship Manager" },
    { icon: <Bot className="w-4 h-4 text-[#4949DE]" />, text: "AI Chat Bot" },
    { icon: <Bot className="w-4 h-4 text-[#4949DE]" />, text: "AI Daily Tasks (coming soon)" },
    { icon: <Bot className="w-4 h-4 text-[#4949DE]" />, text: "AI Data Migration" },
    { icon: <Bot className="w-4 h-4 text-[#4949DE]" />, text: "AI App Downloader" },
    { icon: <Bot className="w-4 h-4 text-[#4949DE]" />, text: "AI Social Media Connector" },
];

const data = [{
    icon: <Megaphone className="w-6 h-6" />,
    iconBg: "bg-blue-100",
    iconColor: "text-[#4949DE]",
    title: "AI Marketing Team – Grow Admissions & Build Your School Brand",
    description: "Your AI team brings more parents to your school without extra work. It builds your website, runs social media, makes reels, and manages marketing — automatically.",
    footer: <div className="space-y-3">
        <Text label={"Results"} cName="text-gray-700 text-xs font-semibold leading-relaxed" />
        {resultsPointsCard1.map((section, index) => (
            <div key={"resultsPointsCard1" + index} className="flex items-center gap-3">
                {!!section.icon && section.icon}
                <Text label={section.text} cName="text-gray-700 text-xs font-semibold leading-relaxed" />
            </div>
        ))}
        <div className="flex flex-wrap items-center gap-2">
            {buttonPointsCard1.map((section, index) => (
                <div key={"buttonPointsCard1" + index} className="flex items-center gap-3 rounded-xl bg-[#F5F5F5] border border-[#E2E8F1] px-2 py-1">
                    {!!section.icon && section.icon}
                    <Text label={section.text} cName="text-gray-700 text-[1.5vh] font-medium text-nowrap whitespace-nowrap" />
                </div>
            ))}
        </div>
    </div>
},{
    icon: <Shapes className="w-6 h-6" />,
    iconBg: "bg-blue-100",
    iconColor: "text-[#4949DE]",
    title: "AI Teaching Team – Build SuperStudents, Reduce Teacher Stress",
    description: "Your classrooms get AI helpers who motivate students, support teachers, and guide parents. They share daily motivation stories, emotional support tips, and study help.",
    footer: <div className="space-y-3">
        <Text label={"Results"} cName="text-gray-700 text-xs font-semibold leading-relaxed" />
        {resultsPointsCard2.map((section, index) => (
            <div key={"resultsPointsCard2" + index} className="flex items-center gap-3">
                {!!section.icon && section.icon}
                <Text label={section.text} cName="text-gray-700 text-xs font-semibold leading-relaxed" />
            </div>
        ))}
        <div className="flex flex-wrap items-center gap-2">
            {buttonPointsCard2.map((section, index) => (
                <div key={"buttonPointsCard2" + index} className="flex items-center gap-3 rounded-xl bg-[#F5F5F5] border border-[#E2E8F1] px-2 py-1">
                    {!!section.icon && section.icon}
                    <Text label={section.text} cName="text-gray-700 text-[1.5vh] font-medium text-nowrap whitespace-nowrap" />
                </div>
            ))}
        </div>
    </div>
},{
    icon: <Settings className="w-6 h-6" />,
    iconBg: "bg-blue-100",
    iconColor: "text-[#4949DE]",
    title: "AI Operations Team – Save ₹25 Lakhs Every Year In Business Losses",
    description: "Your AI team brings more parents to your school without extra work. It builds your website, runs social media, makes reels, and manages marketing — automatically.",
    footer: <div className="space-y-3">
        <Text label={"Results"} cName="text-gray-700 text-xs font-semibold leading-relaxed" />
        {resultsPointsCard3.map((section, index) => (
            <div key={"resultsPointsCard3" + index} className="flex items-center gap-3">
                {!!section.icon && section.icon}
                <Text label={section.text} cName="text-gray-700 text-xs font-semibold leading-relaxed" />
            </div>
        ))}
        <div className="flex flex-wrap items-center gap-2">
            {buttonPointsCard3.map((section, index) => (
                <div key={"buttonPointsCard3" + index} className="flex items-center gap-3 rounded-xl bg-[#F5F5F5] border border-[#E2E8F1] px-2 py-1">
                    {!!section.icon && section.icon}
                    <Text label={section.text} cName="text-gray-700 text-[1.5vh] font-medium text-nowrap whitespace-nowrap" />
                </div>
            ))}
        </div>
    </div>
},{
    icon: <Headset className="w-6 h-6" />,
    iconBg: "bg-blue-100",
    iconColor: "text-[#4949DE]",
    title: "AI Support Team – Fixes Problems Before You Notice Them",
    description: "Your school’s system stays healthy all the time. AI automatically finds and fixes issues — so your team can relax.",
    footer: <div className="space-y-3">
        <Text label={"Results"} cName="text-gray-700 text-xs font-semibold leading-relaxed" />
        {resultsPointsCard4.map((section, index) => (
            <div key={"resultsPointsCard4" + index} className="flex items-center gap-3">
                {!!section.icon && section.icon}
                <Text label={section.text} cName="text-gray-700 text-xs font-semibold leading-relaxed" />
            </div>
        ))}
        <div className="flex flex-wrap items-center gap-2">
            {buttonPointsCard4.map((section, index) => (
                <div key={"buttonPointsCard4" + index} className="flex items-center gap-3 rounded-xl bg-[#F5F5F5] border border-[#E2E8F1] px-2 py-1">
                    {!!section.icon && section.icon}
                    <Text label={section.text} cName="text-gray-700 text-[1.5vh] font-medium text-nowrap whitespace-nowrap" />
                </div>
            ))}
        </div>
    </div>
}];


export default function EachDepartment() {

    return (
        <Box
            badge={"MEET YOUR AI TEAMS"}
            title={"Each department in your school gets its own AI team — working all day, every day."}
            description={"Together, these AI teams run your marketing, teaching, operations, and support — like a real 24×7 workforce working only for your school."}
            leftBlock={data.map((member, index) => <MarktingCard key={"EachDepartment" + index} member={member} />)}
        />
    );
}